import { render, staticRenderFns } from "./resultTable.vue?vue&type=template&id=cd2f04aa&scoped=true"
import script from "./resultTable.vue?vue&type=script&lang=js"
export * from "./resultTable.vue?vue&type=script&lang=js"
import style0 from "./resultTable.vue?vue&type=style&index=0&id=cd2f04aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2f04aa",
  null
  
)

export default component.exports